import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  CardGroup,
  Card,
  CardBody,
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import { SubmissionError } from "redux-form";
import FormLogin from "./formLogin";
import * as session from "../../../services/session";
import { connect } from "react-redux";

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
    };

    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    let viewportmeta = document.querySelector('meta[name="viewport"]');
    viewportmeta.setAttribute("content", "width=device-width, user-scalable=0");
  }

  submit(values) {
    return session
      .authenticate(values.username, values.password)
      .then((data) => {
        let viewportmeta = document.querySelector('meta[name="viewport"]');
        viewportmeta.setAttribute(
          "content",
          "width=device-width, user-scalable=1",
        );

        //Disabled : Fait planter les selects des tableaux
        //this.props.setActivityTime(Date.now());

        this.props.history.push("/seller-dashboard");
      })
      .catch((exception) => {
        throw new SubmissionError({ _error: exception });
      });
  }

  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup className="mb-4">
                <Card className="p-4">
                  <CardBody>
                    <h1 style={{ color: "#4F4F4F" }}>Se connecter</h1>
                    <p className="text-muted">Merci de vous identifier</p>

                    <FormLogin
                      onSubmit={this.submit}
                      history={this.props.history}
                    />
                  </CardBody>
                </Card>
                <Card
                  className="py-5 d-md-down-none"
                  style={{ width: 44 + "%", background: "#4F4F4F" }}
                >
                  <CardBody className="text-center">
                    <div>
                      <img
                        src={"img/icon-app.jpeg"}
                        style={{ maxWidth: "100%", marginBottom: 10 }}
                        alt=""
                      />
                      {/*<h2 style={{color : '#fff'}}></h2>*/}
                      <p style={{ color: "#fff" }}>
                        L'application "TOUT EN UN" de votre Négociant!
                      </p>
                      {/*<Button color="primary" className="mt-3" active>Register Now!</Button>*/}
                    </div>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    activityTime: state.user.lastTimeActitity,
  };
};

const mapDispatchToProps = (dispatch) => ({
  /*//Fait planter le select des tableaux
    setActivityTime: (time) => {
        dispatch({type: 'SET_ACTIVITY_TIME', time});
    }
    */
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Login);

// export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js